import type { Util } from "./util";
import type { SearchSuggest } from "./searchSuggest";
import type { SearchHandler } from "./searchHandler";
import type { Searchbar } from "./searchbar";
import type { OTracking, Tracking } from "./tracking";
import type { DelayedAction } from "./SearchForm";

import { Cache } from "./Cache";
import { templates } from "./templates";
import { util } from "./util";
import { searchSuggest } from "./searchSuggest";
import { searchHandler } from "./searchHandler";
import { searchbar } from "./searchbar";
import { tracking } from "./tracking";
import { SearchForm } from "./SearchForm";

export interface Squirrel {
  searchbar: Searchbar;
  searchHandler: SearchHandler;
  searchSuggest: SearchSuggest;
  templates: Cache;
  cache: { Cache: typeof Cache };
  util: Util;
  searchForm: {
    init: (form: HTMLFormElement, delayedAction: DelayedAction) => SearchForm;
  };
  tracking: Tracking;
}

declare global {
  interface Window {
    o_squirrel: Squirrel;
    o_tracking: OTracking;
    squirrelTrackingInitialized: boolean;
  }
}

window.o_squirrel ||= {} as never;
window.o_squirrel.cache = { Cache };
window.o_squirrel.util = util;
window.o_squirrel.searchForm = {
  init: (form: HTMLFormElement, delayedAction: DelayedAction) => new SearchForm(form, delayedAction),
};
window.o_squirrel.templates = templates;
window.o_squirrel.searchHandler = searchHandler;
window.o_squirrel.tracking = tracking;
window.o_squirrel.searchSuggest = searchSuggest;
window.o_squirrel.searchbar = searchbar;
